import { Input, Component, OnInit } from '@angular/core';
import { MenuParentNode } from '../../menu-nav-bar.model';
import { navigateToOldSetup } from '../../../../shared-module/common/functions/common-helpers';

const MIDDLE_MOUSE_BUTTON = 1;

@Component({
    selector: 'menu-parent-node',
    templateUrl: './menu-parent-node.component.html',
    styleUrls: ['../menu-node.component.scss'],
    standalone: false
})
export class MenuParentNodeComponent implements OnInit {
  @Input('node') node: MenuParentNode;
  public navigateToOldSetup = navigateToOldSetup;

  constructor() { }

  ngOnInit() {
  }

  handleMousedown(node: MenuParentNode, event: MouseEvent) {
    if (event.button === MIDDLE_MOUSE_BUTTON) {
      navigateToOldSetup(node.link, true);
    }
  }
}
